import { render, staticRenderFns } from "./PaginaRegistrazioniContabili.vue?vue&type=template&id=0b0f55d7"
import script from "./PaginaRegistrazioniContabili.vue?vue&type=script&lang=js"
export * from "./PaginaRegistrazioniContabili.vue?vue&type=script&lang=js"
import style0 from "./PaginaRegistrazioniContabili.vue?vue&type=style&index=0&id=0b0f55d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports